
import ShopItemsDan from "./shop-items";
import React, { useEffect, useState } from "react";
import '../../assets/css/style.css';
import { useNavigate } from "react-router-dom";

const ShopsDan = () => {
  const navigate = useNavigate();
  const [shops, setShops] = useState([]); // لیست فروشگاه‌ها
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const donetoken = localStorage.getItem("donetoken");

    if (!donetoken) {
      navigate("/");
    } else {
      // دریافت لیست فروشگاه‌ها از سرور
      fetch(`https://app.doneapp.ir/backend/get_shops.php?token=${donetoken}`)
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "success") {
            setShops(data.shops);
          } else {
            console.error("خطا در دریافت فروشگاه‌ها:", data.message);
          }
        })
        .catch((error) => console.error("خطا در API:", error))
        .finally(() => setLoading(false));
    }
  }, [navigate]);

  return (
    <div className="mohtava-mine">
      <section id="shops" className="dir-r max-cntt-w">
        <div className="shops-div-1">
          <div className="shops-div-2">
            <select className="shop-filter-1">
              <option value="1">بیشترین تخفیف</option>
            </select>
            <select className="shop-filter-2">
              <option value="1">آخرین تخفیفات</option>
            </select>
          </div>
        </div>

        <div className="shops-div-3" id="shops-lists">
          {loading ? (
            <p>در حال بارگذاری...</p>
          ) : (
            shops.map((shop, index) => (
              <ShopItemsDan key={index} shop={shop} />
            ))
          )}
        </div>
      </section>
    </div>
  );
};

export default ShopsDan;
